/**
 * Developed By Aritra Basak, EY
 */
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import { Modal } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Divider } from "@mui/material";
import Paper from "@material-ui/core/Paper";
import { VisibilityOff, Visibility } from "@material-ui/icons";
import { InputAdornment } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { MenuItem } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { Table } from "@material-ui/core";
import { TableBody } from "@material-ui/core";
import { TableCell } from "@material-ui/core";
import { TableRow } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { Checkbox } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import { asyncPost, asyncGet } from "../../../common/utils";
import { URI } from "../../../constants/index";
import "../../../assets/styles/V3.css";

const steps = ["Step 1", "Step 2", "Step 3"];

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "white !important",
  },
  stepper: {
    "& .MuiStepIcon-active": { color: global.secondaryColour },
    "& .MuiStepIcon-completed": { color: global.secondaryColour },
    "& .Mui-disabled .MuiStepIcon-root": { color: "#ccc" },
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(10),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  form: {
    width: "100%",
    padding: theme.spacing(5),
  },
  button: {
    margin: theme.spacing(1),
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
  },
}));

export default function DemoAuthGenerateAbha() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [showLoader, setShowLoader] = React.useState(false);
  const [modalData, setModalData] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [modalError, setModalError] = React.useState(0);
  const [userName, setUserNameValue] = React.useState("");
  const [mobileNumber, setMobileNumberValue] = React.useState("");
  const [showAadhaar, setShowAadhaar] = React.useState(false);
  const [aadhaarId, setAadhaarId] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [pincode, setPincode] = React.useState("");
  const [selectedState, setSelectedState] = React.useState("");
  const [stateList, setStateList] = React.useState([]);
  const [selectedDistrict, setSelectedDistrict] = React.useState("");
  const [districtList, setDistrictList] = React.useState([]);
  const [selectGender, setSelectedGender] = React.useState("");
  const [selectedDateOfBirth, setSelectedDateOfBirth] = React.useState("");
  const [selectDob, setSelectedDob] = React.useState("");
  const [selectDobDay, setSelectedDobDay] = React.useState("");
  const [selectDobMonth, setSelectedDobMonth] = React.useState("");
  const [nameRes, setNameRes] = React.useState("");
  const [healthIdRes, setHealthIdRes] = React.useState("");
  const [healthIdNoRes, setHealthIdNoRes] = React.useState("");
  const [isNewProfile, setIsNewProfile] = React.useState("");
  const [mobileRes, setMobileRes] = React.useState("");
  const [dobRes, setDobRes] = React.useState();
  const [dob, setDob] = React.useState();
  const [genderRes, setGenderRes] = React.useState();
  const [kycPhotoRes, setKycPhotoRes] = React.useState();
  const [healthCard, setHealthCard] = React.useState();
  const [emailRes, setEmailRes] = React.useState("");
  const [profileImageRes, setProfileImageRes] = React.useState();
  const [xToken, setXToken] = React.useState("");
  const [selectedConsentApproval1, setConsentApproval1] = React.useState(false);
  const [selectedConsentApproval2, setConsentApproval2] = React.useState(false);
  const [selectedConsentApproval3, setConsentApproval3] = React.useState(false);
  const [selectedConsentApproval4, setConsentApproval4] = React.useState(false);
  const [selectedConsentApproval5, setConsentApproval5] = React.useState(false);
  const [selectedConsentApproval6, setConsentApproval6] = React.useState(false);
  const [selectedConsentApproval7, setConsentApproval7] = React.useState(false);
  const [benificieryName, setBenificieryName] = React.useState("");
  const [healtCareWorkerName, setHealthCareWorkerName] = React.useState("");
  const [addressRes, setAddressRes] = React.useState("");
  const [districtCodeRes, setDistrictCodeRes] = React.useState("");
  const [stateCodeRes, setStateCodeRes] = React.useState("");
  const [pinCodeRes, setPinCodeRes] = React.useState("");
  const [districtNameRes, setDistrictNameRes] = React.useState("");
  const [stateNameRes, setStateNameRes] = React.useState("");
  const [loaderFor, setLoaderFor] = React.useState("loading");

  const modalWidth = Math.min(500, Math.max(300, modalData.length * 6)) + "px";

  useEffect(() => {
    getStateList();
    if (global.benificiaryName !== "" || global.benificiaryName !== null)
      setBenificieryName(global.benificiaryName);
    if (global.user !== null || global.user !== "")
      setHealthCareWorkerName(global.user);
    if (global.aadharNumber !== "" || global.aadharNumber !== null)
      handleAadhaarId(global.aadharNumber);
    if (global.mobileNumber !== "" || global.mobileNumber !== null)
      handleMobileNumber(global.mobileNumber);
  }, []);

  useEffect(() => {
    if (selectedState != "") {
      getDistrictList();
    }
  }, [selectedState]);

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleModalOpen = (isError = 0) => {
    isError === 0 ? setModalError(0) : setModalError(1);
    setModalState(true);
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  const handleShowAadhaar = () => {
    setShowAadhaar(!showAadhaar);
  };

  const getStateList = async () => {
    setShowLoader(true);
    const res = await asyncGet(
      URI.demoAuthGetStateList,
      true,
      global.token,
      true,
      false
    );
    if (res.status === "Success") {
      setShowLoader(false);
      setStateList(res.resObject);
    } else {
      if (res.status === 500) {
        setShowLoader(false);
        setModalData("Server Side Error.\n" + "Please reload from menu.");
        handleModalOpen(1);
        return false;
      }
      if (res.responseMessage === null) {
        setShowLoader(false);
        setModalData("Message from ABDM : Error! Please reload from menu.");
        handleModalOpen(1);
        return false;
      }
      setShowLoader(false);
      setModalData(
        "Message from ABDM : " +
          res.responseMessage +
          "\n" +
          "Please reload from menu."
      );
      handleModalOpen(1);
      return false;
    }
  };

  const getDistrictList = async () => {
    setShowLoader(true);
    setLoaderFor("district");
    const url = URI.demoAuthGetDistrictList + "?stateCode=" + selectedState;
    const res = await asyncGet(url, true, global.token, true, false);
    if (res.status === "Success") {
      setShowLoader(false);
      setLoaderFor("loading");
      //console.log(res.resObject);
      setDistrictList(res.resObject);
    }
  };

  const handleAadhaarId = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAadhaarId(value);
    } else {
      setAadhaarId((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const handleMobileNumber = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setMobileNumberValue(value);
    } else {
      setMobileNumberValue((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const handlePinCode = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setPincode(value);
    } else {
      setPincode((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const handleUserName = (value) => {
    var alphabetAndSpaceRegex = /^[a-zA-Z\s]*$/; // Allows only alphabets and spaces
    if (value.match(alphabetAndSpaceRegex)) {
      setUserNameValue(value);
    } else {
      setUserNameValue((prevValue) => prevValue); // Keep the previous value if it doesn't match the regex
    }
  };

  const getUserDob = (value) => {
    console.log(value);
    setSelectedDateOfBirth(value);
    var yearOfBirth = String(value).substring(0, 4);
    console.log(yearOfBirth);
    var parts = String(value).split("-");
    console.log("Day", parts[2], "&", "Month", parts[1]);
    setSelectedDobMonth(parts[1]);
    setSelectedDobDay(parts[2]);
    console.log(parts[2] + "-" + parts[1] + "-" + yearOfBirth);
    setSelectedDob(parts[2] + "-" + parts[1] + "-" + yearOfBirth);
  };

  const GenerateAbha = async () => {
    if (userName.trim() === "") {
      setModalData("Kindly enter the User/Patient Name.");
      handleModalOpen();
      return false;
    }
    if (userName.trim().match(/^[a-zA-Z\s]+$/) === null) {
      setModalData("Kindly enter a valid User/Patient Name.");
      handleModalOpen();
      return false;
    }
    if (aadhaarId.trim().length !== 12) {
      setModalData("Kindly enter a proper Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    if (aadhaarId.trim().match(/^[0-9]+$/) === null) {
      setModalData("Kindly enter a proper Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    if (mobileNumber.trim() === "") {
      setModalData("Kindly enter a Mobile Number.");
      handleModalOpen();
      return false;
    }
    if (mobileNumber.trim().match(/^[0-9]+$/) === null) {
      setModalData("Kindly enter a proper Mobile Number.");
      handleModalOpen();
      return false;
    }
    // if (selectedState.trim() === "") {
    //   setModalData("Kindly select a State.");
    //   handleModalOpen();
    //   return false;
    // }
    // if (selectedDistrict.trim() === "") {
    //   setModalData("Kindly select a District.");
    //   handleModalOpen();
    //   return false;
    // }
    if (selectDob.trim() === "") {
      setModalData("Kindly select Date of Birth.");
      handleModalOpen();
      return false;
    }
    if (selectGender.trim() === "") {
      setModalData("Kindly select Gender.");
      handleModalOpen();
      return false;
    }
    const __oo = {
      aadharNumber: aadhaarId,
      name: userName,
      dateOfBirth: selectDob,
      gender: selectGender,
      stateCode: selectedState,
      districtCode: selectedDistrict,
      mobileNumber: mobileNumber,
      address: address,
      pincode: pincode,
    };
    setShowLoader(true);
    const res = await asyncPost(
      URI.demoAuthCreateHealthIdV3,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      console.log(res);
      setNameRes(res.resObject.name);
      setHealthIdRes(res.resObject.healthId);
      setHealthIdNoRes(res.resObject.healthIdNumber);
      setMobileRes(res.resObject.mobile);
      const day =
        res.resObject.dayOfBirth === null
          ? selectDobDay
          : res.resObject.dayOfBirth.trim().length === 1
          ? "0" + res.resObject.dayOfBirth
          : res.resObject.dayOfBirth;

      const month =
        res.resObject.monthOfBirth === null
          ? selectDobMonth
          : res.resObject.monthOfBirth.trim().length === 1
          ? "0" + res.resObject.monthOfBirth
          : res.resObject.monthOfBirth;
      setDob(day + "/" + month + "/" + res.resObject.yearOfBirth);
      res.resObject.dayOfBirth === null && res.resObject.monthOfBirth === null
        ? setDobRes(res.resObject.yearOfBirth)
        : setDobRes(day + "/" + month + "/" + res.resObject.yearOfBirth);
      setGenderRes(res.resObject.gender);
      setXToken(res.resObject.token);
      setIsNewProfile(res.resObject.new);
      setEmailRes(res.resObject.email);
      setProfileImageRes(res.resObject.profilePhoto);
      setAddressRes(res.resObject.address);
      setDistrictCodeRes(res.resObject.districtCode);
      setStateCodeRes(res.resObject.stateCode);
      setPinCodeRes(
        res.resObject.pincode !== null ? res.resObject.pincode : pincode
      );
      setDistrictNameRes(res.resObject.districtName);
      setStateNameRes(res.resObject.stateName);
      setShowLoader(false);
      setModalData("ABHA Profile Created Successfully.");
      handleModalOpen();
      handleNext();
      // To fetch the the Profile Photo
      // const __oo2 = {
      //   xToken: res.resObject.token,
      // };
      // const res2 = await asyncPost(
      //   URI.demoAuthGetProfile,
      //   __oo2,
      //   true,
      //   true,
      //   global.token
      // );
      // if (res2.status === "Success") {
      //   setProfileImageRes(res2.resObject.profilePhoto);
      //   setKycPhotoRes(res2.resObject.kycPhoto);
      // }
      // setShowLoader(false);
      // setModalData("ABHA Profile Created Successfully.");
      // setModalState(true);
      // handleNext();
    } else {
      setShowLoader(false);
      //debugger;
      if (
        res.resObject &&
        res.resObject.details &&
        res.resObject.details.length > 0 &&
        res.resObject.details[0].message &&
        res.resObject.details[0].message.attribute &&
        res.resObject.details[0].message.attribute.key === "aadharNumber"
      ) {
        console.log(
          res.resObject.details[1]?.message ||
            "Failure Creating the ABHA Profile"
        );
        setModalData(
          res.resObject.details[1]?.message ||
            "Failure Creating the ABHA Profile"
        );
        handleModalOpen(1);
        return false;
      } else if (
        res.resObject &&
        res.resObject.details &&
        res.resObject.details.length > 0 &&
        res.resObject.details[0].message
      ) {
        //console.log(res.resObject.details[0].message);
        setModalData(res.resObject.details[0].message);
        handleModalOpen(1);
        return false;
      } else {
        console.log(res.responseMessage || "Failure Creating the ABHA Profile");
        setModalData(
          res.responseMessage || "Failure Creating the ABHA Profile"
        );
        handleModalOpen(1);
        return false;
      }
    }
  };

  const getHealthCard = async () => {
    setShowLoader(true);
    const __oo = {
      token: xToken,
    };
    // debugger;
    const res = await asyncPost(
      URI.demoAuthGetHealthCardV3,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === "Success") {
      //debugger;
      setHealthCard(res.resObject);
      handleNext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      setModalData("Message from ABDM :" + res.responseMessage);
      handleModalOpen(1);
      return false;
    }
  };

  const downloadPng = async () => {
    window.location.href = "data:application/octet-stream;base64," + healthCard;
    var a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + healthCard; //Image Base64 Goes here
    a.download = "DemoGraphicsHealthCard.png"; //File name Here
    a.click(); //Downloaded file
  };

  const checkBoxApproval1 = () => {
    setConsentApproval1(!selectedConsentApproval1);
  };
  const checkBoxApproval2 = () => {
    setConsentApproval2(!selectedConsentApproval2);
  };
  const checkBoxApproval3 = () => {
    setConsentApproval3(!selectedConsentApproval3);
  };
  const checkBoxApproval4 = () => {
    setConsentApproval4(!selectedConsentApproval4);
  };
  const checkBoxApproval5 = () => {
    setConsentApproval5(!selectedConsentApproval5);
    setConsentApproval6(!selectedConsentApproval6);
    setConsentApproval7(!selectedConsentApproval7);
  };
  // const checkBoxApproval6 = () => {
  //   setConsentApproval6(!selectedConsentApproval6);
  // };
  // const checkBoxApproval7 = () => {
  //   setConsentApproval7(!selectedConsentApproval7);
  // };

  const handleAcknowledgeAll = () => {
    setConsentApproval1(true);
    setConsentApproval2(true);
    setConsentApproval3(true);
    setConsentApproval4(true);
    setConsentApproval5(true);
    setConsentApproval6(true);
    setConsentApproval7(true);
  };

  const backToHome = async () => {
    console.log(dobRes);
    postMessageToParent();
    //setActiveStep(0);
    resetHooks();
  };

  //This Event is trigerred from the parent web UI.
  window.addEventListener("message", function (event) {
    if (event.data === "closeWindow") {
      postMessageToParent();
    }
  });

  const postMessageToParent = async () => {
    const __oo = {
      name: nameRes,
      healthId: healthIdRes,
      healthIdNumber: healthIdNoRes,
      gender: genderRes,
      mobile: mobileRes !== "" || mobileRes !== null ? mobileRes : mobileNumber,
      dob: dob,
      isNew: isNewProfile,
      yearOfBirth: dob
        .trim()
        .substring(dob.trim().length - 4, dob.trim().length),
      pngCard: profileImageRes,
      kycPhoto: kycPhotoRes,
      address: addressRes,
      districtCode: districtCodeRes,
      stateCode: stateCodeRes,
      pinCode: pincode,
      aadhaarNumber: aadhaarId,
    };
    console.log(__oo);
    window.parent.postMessage(JSON.stringify(__oo), "*");
  };

  const resetHooks = () => {
    setAadhaarId("");
    setUserNameValue("");
    setSelectedGender("");
    setSelectedDob("");
    setMobileNumberValue("");
    setSelectedDistrict("");
    setSelectedState("");
    setAddress("");
    setLoaderFor("loading");
    setPincode("");
  };

  const generateScreen = () => {
    if (activeStep == 0) {
      return populateScreenFlowOne();
    } else if (activeStep == 1) {
      return populateScreenFlowTwo();
    } else if (activeStep == 2) {
      return populateScreenFlowThree();
    }
  };

  const populateScreenFlowOne = () => {
    return (
      <div>
        <form
          className={classes.form}
          noValidate
          style={{ overflow: "hidden" }}
        >
          <Grid container direction={"column"} spacing={2}>
            <Grid item>
              <div
                className="text-center"
                style={{
                  color: "#2E4374",
                  fontWeight: "bold",
                }}
              >
                User Details
              </div>
            </Grid>
            <Grid item>
              <div className={"demographicsFieldBox"}>
                <TextField
                  variant="standard"
                  margin="normal"
                  label={"Enter your Name"}
                  required
                  id="userName"
                  value={userName}
                  name="healthId"
                  style={{ marginTop: -1, width: "300px" }}
                  onChange={(e) => handleUserName(e.target.value)}
                />

                <TextField
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleShowAadhaar} edge="end">
                          {showAadhaar ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    readOnly:
                      global.clientId === 11 &&
                      aadhaarId !== null &&
                      aadhaarId !== "" &&
                      aadhaarId.trim().length == 12,
                  }}
                  value={aadhaarId}
                  autoFocus
                  id="aadhaarId"
                  label="Aadhaar Number"
                  required
                  variant="standard"
                  type={showAadhaar ? "text" : "password"}
                  style={{ marginTop: -5, width: "300px" }}
                  onChange={(e) => handleAadhaarId(e.target.value)}
                  inputProps={{
                    maxLength: 12,
                    readOnly:
                      global.clientId === 11 &&
                      aadhaarId !== null &&
                      aadhaarId !== "" &&
                      aadhaarId.trim().length == 12,
                  }}
                />
              </div>
            </Grid>
            <Grid item>
              <div className="demographicsFieldBox">
                <div className="text-start">
                  <InputLabel id="state-select-label">Select State</InputLabel>
                  <Select
                    fullWidth
                    labelId="state-select-label"
                    id="state-select"
                    value={selectedState}
                    onChange={(event) => setSelectedState(event.target.value)}
                    style={{ width: "300px" }}
                  >
                    <MenuItem value="" disabled>
                      Select State Name
                    </MenuItem>
                    {stateList.map((address) => (
                      <MenuItem key={address} value={address.code}>
                        {address.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="text-start">
                  <InputLabel id="district-select-label">
                    Select District
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="district-select-label"
                    id="district-select"
                    value={selectedDistrict}
                    onChange={(event) =>
                      setSelectedDistrict(event.target.value)
                    }
                    style={{ width: "300px" }}
                  >
                    <MenuItem value="" disabled>
                      Select District Name
                    </MenuItem>
                    {districtList.map((address) => (
                      <MenuItem key={address} value={address.code}>
                        {address.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </Grid>
            <Grid item>
              <div className={"demographicsFieldBox"}>
                <TextField
                  id="date"
                  label="Date of Birth"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: "300px" }}
                  onChange={(event) => getUserDob(event.target.value)}
                  value={selectedDateOfBirth}
                />
                <div className="text-start">
                  <InputLabel id="address-select-label">
                    Select Gender
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="gender-select-label"
                    id="gender-select"
                    value={selectGender}
                    onChange={(event) => setSelectedGender(event.target.value)}
                    style={{ width: "300px" }}
                  >
                    <option
                      value=""
                      style={{ fontSize: "18px", margin: "5px" }}
                      disabled
                    >
                      Select Gender
                    </option>
                    <option
                      value="M"
                      style={{ fontSize: "18px", margin: "5px" }}
                    >
                      Male
                    </option>
                    <option
                      value="F"
                      style={{ fontSize: "18px", margin: "5px" }}
                    >
                      Female
                    </option>
                    <option
                      value="O"
                      style={{ fontSize: "18px", margin: "5px" }}
                    >
                      Other
                    </option>
                  </Select>
                </div>
              </div>
            </Grid>
            <Grid item>
              <div className="demographicsFieldBox">
                <TextField
                  variant="standard"
                  margin="normal"
                  label={"Enter Communication Mobile Number"}
                  required
                  id="mobileNumber"
                  value={mobileNumber}
                  name="mobileNumber"
                  style={{ marginTop: -1, width: "300px" }}
                  onChange={(e) => handleMobileNumber(e.target.value)}
                  inputProps={{
                    maxLength: 10,
                    readOnly:
                      global.clientId === 11 &&
                      aadhaarId !== null &&
                      aadhaarId !== "" &&
                      mobileNumber.trim().length == 10,
                  }}
                />
                <TextField
                  variant="standard"
                  margin="normal"
                  label={"Enter your Address"}
                  required
                  id="address"
                  value={address}
                  name="address"
                  style={{ marginTop: -1, width: "300px" }}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <TextField
                variant="standard"
                margin="normal"
                label={"Enter your Pincode"}
                required
                id="pincode"
                value={pincode}
                name="pincode"
                style={{ marginTop: -1, width: "300px" }}
                onChange={(e) => handlePinCode(e.target.value)}
                inputProps={{ maxLength: 6 }}
              />
            </Grid>

            <Grid item>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ fontSize: "0.7rem" }}>
                  I hereby declare that:
                </span>
                <Button
                  variant="default"
                  style={{ color: "#f53169d9" }}
                  onClick={() => handleAcknowledgeAll()}
                >
                  Accept All
                </Button>
              </div>
              <div id="consent_div" style={{ marginTop: 10 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedConsentApproval1 ? true : false}
                      onChange={() => {
                        checkBoxApproval1();
                      }}
                      name="selectedConsentApproval1"
                    />
                  }
                  label={
                    <p style={{ fontSize: "0.7rem" }}>
                      I am voluntarily sharing my Aadhaar Number / Virtual ID
                      issued by the Unique Identification Authority of India (“
                      <strong>UIDAI</strong>”), and my demographic information
                      for the purpose of creating an Ayushman Bharat Health
                      Account number (“
                      <strong>ABHA number</strong>”) and Ayushman Bharat Health
                      Account address (“<strong>ABHA Address</strong>
                      ”). I authorize NHA to use my Aadhaar number / Virtual ID
                      for performing Aadhaar based authentication with UIDAI as
                      per the provisions of the Aadhaar (Targeted Delivery of
                      Financial and other Subsidies, Benefits and Services) Act,
                      2016 for the aforesaid purpose. I understand that UIDAI
                      will share my e-KYC details, or response of “Yes” with NHA
                      upon successful authentication.
                    </p>
                  }
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedConsentApproval2 ? true : false}
                      onChange={() => {
                        checkBoxApproval2();
                      }}
                      name="selectedConsentApproval2"
                    />
                  }
                  label={
                    <p style={{ fontSize: "0.7rem" }}>
                      I intend to create Ayushman Bharat Health Account Number
                      (“
                      <strong>ABHA number</strong>”) and Ayushman Bharat Health
                      Account address (“<strong>ABHA Address</strong>
                      ”) using document other than Aadhaar.
                    </p>
                  }
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedConsentApproval3 ? true : false}
                      onChange={() => {
                        checkBoxApproval3();
                      }}
                      name="selectedConsentApproval3"
                    />
                  }
                  label={
                    <p style={{ fontSize: "0.7rem" }}>
                      I consent to usage of my ABHA address and ABHA number for
                      linking of my legacy (past) health records and those which
                      will be generated during this encounter.
                    </p>
                  }
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedConsentApproval4 ? true : false}
                      onChange={() => {
                        checkBoxApproval4();
                      }}
                      name="selectedConsentApproval4"
                    />
                  }
                  label={
                    <p style={{ fontSize: "0.7rem" }}>
                      I authorize the sharing of all my health records with
                      healthcare provider(s) for the purpose of providing
                      healthcare services to me during this encounter.
                    </p>
                  }
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedConsentApproval5 ? true : false}
                      onChange={() => {
                        checkBoxApproval5();
                      }}
                      name="selectedConsentApproval5"
                    />
                  }
                  label={
                    <p style={{ fontSize: "0.7rem" }}>
                      I consent to the anonymization and subsequent use of my
                      health records for public health purposes.
                    </p>
                  }
                />

                {global.user == "" ? (
                  <FormControlLabel
                    style={{ marginLeft: 20 }}
                    control={
                      <Checkbox
                        checked={selectedConsentApproval6 ? true : false}
                        // onChange={() => {
                        //   checkBoxApproval6();
                        // }}
                        name="selectedConsentApproval6"
                      />
                    }
                    label={
                      <p style={{ fontSize: "0.7rem" }}>
                        I,{" "}
                        <TextField
                          placeholder="healthcare worker name"
                          onChange={(e) =>
                            setHealthCareWorkerName(e.target.value)
                          }
                        />
                        , confirm that I have duly informed and explained the
                        beneficiary of the contents of consent for
                        aforementioned purposes.
                      </p>
                    }
                  />
                ) : (
                  <FormControlLabel
                    style={{ marginLeft: 20 }}
                    control={
                      <Checkbox
                        checked={selectedConsentApproval6 ? true : false}
                        // onChange={() => {
                        //   checkBoxApproval6();
                        // }}
                        name="selectedConsentApproval6"
                      />
                    }
                    label={
                      <p style={{ fontSize: "0.7rem" }}>
                        I,{" "}
                        <TextField
                          placeholder="healthcare worker name"
                          disabled={true}
                          value={global.user}
                        />
                        , confirm that I have duly informed and explained the
                        beneficiary of the contents of consent for
                        aforementioned purposes.
                      </p>
                    }
                  />
                )}

                {global.benificiaryName === "" ? (
                  <FormControlLabel
                    style={{ marginLeft: 20 }}
                    control={
                      <Checkbox
                        checked={selectedConsentApproval5 ? true : false}
                        // onChange={() => {
                        //   checkBoxApproval7();
                        // }}
                        name="selectedConsentApproval7"
                      />
                    }
                    label={
                      <p style={{ fontSize: "0.7rem" }}>
                        I,{" "}
                        <TextField
                          placeholder="beneficiary name"
                          onChange={(e) => setBenificieryName(e.target.value)}
                          value={benificieryName}
                        />
                        , have been explained about the consent as stated above
                        and hereby provide my consent for the aforementioned
                        purposes.
                      </p>
                    }
                  />
                ) : (
                  <FormControlLabel
                    style={{ marginLeft: 20 }}
                    control={
                      <Checkbox
                        checked={selectedConsentApproval5 ? true : false}
                        // onChange={() => {
                        //   checkBoxApproval7();
                        // }}
                        name="selectedConsentApproval7"
                      />
                    }
                    label={
                      <p style={{ fontSize: "0.7rem" }}>
                        I,{" "}
                        <TextField
                          placeholder="beneficiary name"
                          value={global.benificiaryName}
                          disabled={true}
                        />
                        , have been explained about the consent as stated above
                        and hereby provide my consent for the aforementioned
                        purposes.
                      </p>
                    }
                  />
                )}
              </div>
            </Grid>
            <Grid item>
              <div className="text-center my-2">
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor:
                      selectedConsentApproval1 &&
                      selectedConsentApproval2 &&
                      selectedConsentApproval3 &&
                      selectedConsentApproval4 &&
                      selectedConsentApproval5 &&
                      selectedConsentApproval7 &&
                      benificieryName.trim() != ""
                        ? global.secondaryColour
                        : "#ccc",
                    color: "#fff",
                    paddingBottom: 10,
                    width: "200px",
                  }}
                  className={classes.submit}
                  onClick={() => GenerateAbha()}
                  disabled={
                    selectedConsentApproval1 &&
                    selectedConsentApproval2 &&
                    selectedConsentApproval3 &&
                    selectedConsentApproval4 &&
                    selectedConsentApproval5 &&
                    selectedConsentApproval7 &&
                    benificieryName.trim() != ""
                      ? false
                      : true
                  }
                >
                  Submit
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  };

  const populateScreenFlowTwo = () => {
    const kycPhotoImage = "data:image/png;base64, " + profileImageRes;
    return (
      <Table size="big">
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Number</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{healthIdNoRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Address</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{healthIdRes}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Name</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{nameRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Gender</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {genderRes == "M" ? "Male" : "Female"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Mobile</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{mobileRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Date of Birth</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{dob}</TableCell>
          </TableRow>
          {stateNameRes !== null &&
          districtNameRes !== null &&
          stateNameRes.trim() != "" &&
          districtNameRes.trim() != "" ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>State</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {stateNameRes}
              </TableCell>

              <TableCell style={{ textAlign: "left" }}>
                <strong>District</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>
                {districtNameRes}
              </TableCell>
            </TableRow>
          ) : (
            ""
          )}
          {pinCodeRes !== null &&
          addressRes !== null &&
          addressRes.trim() !== "" &&
          pinCodeRes.trim() !== "" ? (
            <TableRow>
              <TableCell style={{ textAlign: "left" }}>
                <strong>Address</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>{addressRes}</TableCell>

              <TableCell style={{ textAlign: "left" }}>
                <strong>Pincode</strong>
              </TableCell>
              <TableCell style={{ textAlign: "left" }}>{pinCodeRes}</TableCell>
            </TableRow>
          ) : (
            ""
          )}
          <TableRow>
            <TableCell colSpan={4} className="imgcontainer">
              <div className="text-center">
                <img src={kycPhotoImage} />
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                }}
                onClick={() => getHealthCard()}
              >
                View ABHA Card
              </Button>
              <Button
                variant="contained"
                className="mx-2"
                color="default"
                style={{
                  backgroundColor: "#f53169d9",
                  color: "#fff",
                }}
                onClick={() => backToHome()}
              >
                Save and Continue
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  const populateScreenFlowThree = () => {
    const pngCardImage = "data:image/png;base64, " + healthCard;
    return (
      <div className="text-center">
        <img src={pngCardImage} width={"80%"} />

        <div style={{ textAlign: "center" }} className="my-2">
          <Button
            variant="contained"
            className="mx-2"
            style={{
              backgroundColor: global.secondaryColour,
              color: "#fff",
            }}
            onClick={() => downloadPng()}
          >
            Download ABHA Card
          </Button>
          <Button
            variant="contained"
            className="mx-2"
            color="default"
            style={{
              backgroundColor: "#f53169d9",
              color: "#fff",
            }}
            onClick={() => backToHome()}
          >
            Save and Continue
          </Button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} style={{ padding: "10px" }}>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {showLoader ? (
              <div style={{ textAlign: "center", marginTop: 60 }}>
                <CircularProgress style={{ color: global.secondaryColour }} />
                {loaderFor === "loading" ? (
                  <h5 style={{ marginTop: 5 }}>Loading...</h5>
                ) : (
                  <h5 style={{ marginTop: 5 }}>Fetching District List...</h5>
                )}
              </div>
            ) : (
              generateScreen()
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                pt: 2,
                marginRight: 20,
              }}
            ></Box>
          </React.Fragment>
        )}
      </Paper>
      <Modal
        open={modalState}
        onClose={handleModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        BackdropProps={{ timeout: 500 }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Fade in={modalState}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Ensures full viewport height for centering
            }}
          >
            <Box
              sx={{
                background: "white",
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
                p: 3,
                minWidth: "300px",
                maxWidth: "80vw",
                width: modalWidth,
                boxShadow: 24,
              }}
            >
              {modalError === 1 ? (
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 50 50"
                    className="me-2"
                    width="25px"
                    height="27px"
                    fill="#000000"
                  >
                    <circle
                      style={{ fill: "#D75A4A" }}
                      cx="25"
                      cy="25"
                      r="25"
                    />
                    <polyline
                      style={{
                        fill: "none",
                        stroke: "#FFFFFF",
                        strokeWidth: 2,
                        strokeLinecap: "round",
                        strokeMiterlimit: 10,
                      }}
                      points="16,34 25,25 34,16"
                    />
                    <polyline
                      style={{
                        fill: "none",
                        stroke: "#FFFFFF",
                        strokeWidth: 2,
                        strokeLinecap: "round",
                        strokeMiterlimit: 10,
                      }}
                      points="16,16 25,25 34,34"
                    />
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Error
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    width="25"
                    height="27"
                    viewBox="0 0 128 128"
                    className="me-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <style>
                        {`.cls-1{fill:#ffe082}
                        .cls-2{fill:#404040}
                        .cls-3{fill:#9e9e9e}
                        .cls-4{fill:#f5f5f5}`}
                      </style>
                    </defs>
                    <path
                      className="cls-1"
                      d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                    />
                    <path
                      className="cls-2"
                      d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                    />
                    <path
                      className="cls-3"
                      d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                    />
                    <path
                      className="cls-2"
                      d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="102" y2="98" />
                    <path
                      className="cls-2"
                      d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="110" y2="106" />
                    <path
                      className="cls-2"
                      d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Information
                  </Typography>
                </Box>
              )}
              {/* Decorative Lines */}
              <Divider sx={{ width: "50%", mb: 0.5 }} />
              <Divider sx={{ width: "40%", mb: 2 }} />
              <Typography
                variant="body1"
                sx={{ whiteSpace: "pre-wrap", mb: 2 }}
              >
                {modalData}
              </Typography>
              <Button
                variant="contained"
                style={{
                  backgroundColor: global.secondaryColour,
                  color: "#fff",
                  paddingBottom: 10,
                  marginTop: 7,
                }}
                onClick={handleModalClose}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}
